import { ref, onMounted } from 'vue';

/**
 * Composable for handling URL search parameters
 * Automatically extracts and manages search terms from URL
 */
export function useUrlSearch() {
    const searchValue = ref('');
    const hasInitialSearch = ref(false);

    /**
     * Extract search parameter from current URL
     */
    const getInitialSearchValue = (): string => {
        const urlParams = new URLSearchParams(window.location.search);
        const search = urlParams.get('search') || '';
        hasInitialSearch.value = !!search;
        return search;
    };

    /**
     * Initialize search value from URL
     */
    const initializeFromUrl = () => {
        searchValue.value = getInitialSearchValue();
    };

    /**
     * Clean search parameter from URL (call after processing)
     */
    const cleanUrlParameter = () => {
        if (hasInitialSearch.value) {
            const url = new URL(window.location.href);
            url.searchParams.delete('search');
            window.history.replaceState({}, document.title, url.toString());
        }
    };

    /**
     * Get search value and clean URL in one call
     */
    const extractAndCleanSearch = (): string => {
        const search = getInitialSearchValue();
        if (search) {
            // Clean URL after a short delay to ensure state is set
            setTimeout(cleanUrlParameter, 100);
        }
        return search;
    };

    return {
        searchValue,
        hasInitialSearch,
        getInitialSearchValue,
        initializeFromUrl,
        cleanUrlParameter,
        extractAndCleanSearch,
    };
}
